import React, { Component } from 'react'
import { connect } from 'react-redux'
import T from 'prop-types'
import { FormattedMessage, injectIntl } from 'react-intl'
import Button from '@material-ui/core/Button'
import ForgotPasswordForm from 'components/auth/ForgotPassword/ForgotPassword'
import { forgotPassword } from 'reducers/auth/reducer'
import withPromise from 'helpers/withPromise'
import Locale from 'components/common/Locale/Locale'
import * as ROUTE from 'constants/appRouting'
import messages from './translate'

class ForgotPassword extends Component {
  forgotPassword = data => {
    const { forgotPassword, history } = this.props

    return withPromise(forgotPassword, data).then(res => {
      if (res && res.error) {
        return Promise.resolve(res)
      }

      history.push(ROUTE.LOGIN)
    })
  }

  onBackToLogin = () => {
    const { history } = this.props

    history.replace(ROUTE.LOGIN)
  }

  render() {
    return (
      <div className="forgot-password-form">
        <div className="form-headline">
          <h2>
            <FormattedMessage {...messages.forgot_password} />
          </h2>
          <Locale />
        </div>
        <hr />
        <ForgotPasswordForm onSubmit={this.forgotPassword} />
        <Button
          fullWidth
          href={null}
          color="default"
          size="large"
          variant="contained"
          type="button"
          onClick={this.onBackToLogin}>
          <FormattedMessage {...messages.back_to_signin} />
        </Button>
      </div>
    )
  }
}

ForgotPassword.propTypes = {
  history: T.shape({
    push: T.func.isRequired,
    replace: T.func.isRequired,
  }).isRequired,
  forgotPassword: T.func.isRequired,
}

const enhance = connect(null, { forgotPassword })

export default enhance(injectIntl(ForgotPassword))
